import type { SVGProps } from "react";

export function IconVideoSpeed(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      aria-hidden="true"
      fill="none"
      height="18"
      viewBox="0 0 20 20"
      width="18"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Video playback speed</title>
      <circle cx="10" cy="10" r="8.5" stroke="white" strokeWidth="1.5" />
      <path
        d="M10 10 L14 6"
        stroke="white"
        strokeLinecap="round"
        strokeWidth="1.5"
      />
      <circle cx="10" cy="10" fill="white" r="1.5" />
    </svg>
  );
}
